// app/javascript/controllers/demissoes/approvals_controller.js

import { Controller } from "@hotwired/stimulus";
import { initDemissoesBulkApproval } from "../../modules/demissoes/bulk_approval";
import { createDemissoesApprovalsService } from "../../services/demissoes_approvals_service";

export default class extends Controller {
  static values = {
    bulkUrl: String,
  };

  connect() {
    this.service = createDemissoesApprovalsService({
      bulkUrl: this.bulkUrlValue,
    });

    this.bulk = initDemissoesBulkApproval(this.element, this.service);
  }

  disconnect() {
    this.bulk?.destroy?.();
  }
}
